import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-insurance-details',
  templateUrl: './edit-insurance-details.component.html',
  styleUrls: ['./edit-insurance-details.component.css']
})
export class EditInsuranceDetailsComponent implements OnInit {
  data: any ={};
  value: any;
  id: any;
  type: any;
  policyType: any;
  insurer: any;
  policyNumber: any;
  renewalDate: any;
  productName: any;
  premium: any;
  sumAssured: any;
  daysBeforeDueDate: any;
  weeksBeforeDueDate: any;
  monthsBeforeDueDate: any;
  public array:any = [];
  selectedFile: File;
  attachImage: File;
  insuranceDetails: Array<any> = [];
  updatedTime : any;
  backgroundAttached: Array<any> = [];
  error: any;
  fieldDetails: Array<any> = [];
  dynamicFields: any;
  disabledButton : boolean = false;
  loading: boolean = false;
  policyId: any;
  editData: any;
  
  private onDestroy$: Subject<void> = new Subject<void>();
  onFileChanged(event) {
    this.selectedFile = event.target.files[0]
  }


  onUpload() {
    // upload code goes here
  }
 

  constructor(private router: Router, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.insurance()
  }

 
  
  updateInsuranceDetails(){
    this.loading = true;
    this.renewalDate = new Date(this.data.dueDate).getTime();
    this.data.fields = [
       { "value": this.editData.policyType, id: 'policyType', type: 'TEXT', visibility: true },
       { "value": this.editData.insurer, id: 'insurer', type: 'TEXT', visibility: true },
       { "value": this.editData.policyNumber, id: 'policyNumber', type: 'NUMBER', visibility: true },
       { "value": this.editData.renewalDate, id: 'renewalDate', type: 'DATE', visibility: true },
       { "value": this.editData.productName, id: 'productName', type: 'TEXT', visibility: true },
       { "value": this.editData.premium, id: 'premium', type: 'TEXT', visibility: true },
       { "value": this.editData.sumAssured, id: 'sumAssured', type: 'NUMBER', visibility: true } 
    ]

    this.data.reminders = [];
     this.data.reminders.push({ 
      'daysBeforeDueDate': this.data.daysBeforeDueDate,
      'weeksBeforeDueDate': this.data.weeksBeforeDueDate,
      'monthsBeforeDueDate': this.data.monthsBeforeDueDate,
    });
    

    this.data = {
      "fields": (this.data.fields),
      "attachments":[],
      "linkedToCard": 'false',
      "dynamic_fields": [],
      "reminders": (this.data.reminders),
      "isSynced": 'false',
      "id": this.policyId
    }


    console.log("updated requested data ",this.data);
    //return false;
    //let selectedDates = [];
    

    this.serviceURLService.updateInsurance(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      console.log("Policy updated successfully")
      this.router.navigate(['insurances']);
      this.loading = false;
    }, errorData => {
      if(errorData.error.status === 401){
        localStorage.clear();
        alert("Login session has been expired..!! Please Login again.")
        this.router.navigate(['login']);
      }
      console.log("Error");
    })
  }

  insurance(){
    this.loading = true;
    this.data = {
      "updatedTime": null,
      
    }
    this.fieldDetails = []
    this.serviceURLService.insurance(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.insuranceDetails = successData.response.policies;
      this.loading = false;
      
      for (let i = 0; i < (successData.response.policies).length; i++) {
        if(window.location.href.substring(window.location.href.lastIndexOf('/') + 1) == successData.response.policies[i]._id){          
          this.fieldDetails = successData.response.policies[i].fields
          this.dynamicFields = successData.response.policies[i].dynamic_fields
          this.policyId = successData.response.policies[i]._id
          this.editData = {
            "policyType" :  successData.response.policies[i].fields[0].value,
            "insurer" :  successData.response.policies[i].fields[1].value,
            "policyNumber" : successData.response.policies[i].fields[2].value,
            "renewalDate" : new Date(successData.response.policies[i].fields[3].type),
            "productName" : successData.response.policies[i].fields[4].value,
            "premium" : successData.response.policies[i].fields[5].value,
            "sumAssured" : successData.response.policies[i].fields[6].value,
          }
          if(this.dynamicFields.length > 0){
            this.disabledButton = true;
          }
          // for (let j = 0; j < (successData.response.policies[i].fields).length; j++){
          //   console.log("acha ",successData.response.policies[i].fields[j].value)
          //   this.fieldDetails.push({
          //     policyType: successData.response.policies[i].fields[0].value,
          //     insurer: successData.response.policies[i].fields[1].value,
          //     policyNumber: successData.response.policies[i].fields[2].value,
          //     renewalDate : successData.response.policies[i].fields[3].type,
          //     productName : successData.response.policies[i].fields[4].value,
          //     premium : successData.response.policies[i].fields[5].value,
          //     sumAssured : successData.response.policies[i].fields[6].value              
          //   })
          // }
          // this.fieldDetails.push({
          //   type: successData.response.policies[i].attachments[0].nativePath
          // })
        }
      }
    }, errorData => {
      if(errorData.error.status === 401){
        this.router.navigate(['login']);
      }else if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
      console.log("not registered");
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    
}
